/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    '팀 또는 관리자에게 지원을 요청하세요.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    '이 검색에 대한 결과를 가져올 수 없습니다',
};
